import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import type { Region } from '@/interfaces/locale-details';
import { WEB_LOCALES_BY_REGION } from '@/constants/web-locales.constant';
import { useI18n } from '@/helpers/composables/useI18n';
import { storeToRefs } from 'pinia';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'CountriesListByRegion',
  props: {
    region: null,
    cols: { default: 1 }
  },
  setup(__props: any) {

const props = __props as { region: Region, cols: number };



const { activeLocalesList } = storeToRefs(useLanguageStore());
const { tc } = useI18n();

const regionCountries = computed(() => {
	const countries = WEB_LOCALES_BY_REGION[props.region]
		.filter(locale => locale in activeLocalesList.value)
		.map(locale => ({ locale, name: tc(`WEBAPP_COUNTRY_${locale.toUpperCase()}`) }));

	countries.sort((a, b) => a.name.localeCompare(b.name));

	return countries;
});

const countriesByCol = computed(() => {
	const itemsPerCol = Math.ceil(regionCountries.value.length / props.cols);

	return Array.from({ length: props.cols }, (_, i) => i * itemsPerCol).map(begin =>
		regionCountries.value.slice(begin, begin + itemsPerCol)
	);
});

return { __sfc: true,props, activeLocalesList, tc, regionCountries, countriesByCol }
}

})